/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */


var uploadAvatar = {
    init: function($wrapper, params) {
        var defaults = {
            crop: true,
            resize: true,
        };
        params = $.extend({}, defaults, params);
        var $btnRemove = $wrapper.find('.rmv-photo');
        var $btnSubmit = $wrapper.find('.btn-insert-photo');
        var $load      = $wrapper.find('.load');

        new Dropzone($wrapper.get(0), {
            headers: {'X-CSRF-TOKEN': $(document).find('meta[name="csrf-token"]').attr('content')},
            url: base + '/upload',
            params: {
                "content_type": params.content_type,
                "w": params.w,
                "h": params.h,
                "crop": params.crop,
                "resize": params.resize,
            },
            clickable: $btnSubmit.get(0),
            uploadMultiple: true,
            paramName: 'files',
            acceptedFiles: '.jpg, .jpeg, .png',
            init: function() {
                this.on('addedfile', function(file) {
                    $wrapper.find('.dz-preview').remove();
                });
                this.on('sendingmultiple', function(file, xhr, formData) {
                    // $wrapper.find('.progress-group').show();
                });
                this.on('totaluploadprogress', function(progress) {
                    $load.show();
                    $btnSubmit.attr('disabled', 'disabled');
                });
                this.on('successmultiple', function(file, res) {

                    if(res.error) {
                        alert(res.message);
                    } else {
                        $btnSubmit.removeAttr('disabled');
                        $(res).each(function(index, file) {
                            $wrapper.find('.preview img').attr('src', file.file_item_public_url);
                            $.ajax({
                                headers: {'X-CSRF-TOKEN': $(document).find('meta[name="csrf-token"]').attr('content')},
                                type: 'POST',
                                url: base + '/pt/minhas-acoes/actions',
                                data: {
                                    action: 'save-photo',
                                    image: file.file_item_name,
                                },
                                success: function(response) {
                                    $load.hide();
                                    if(response.error) alert('Erro na requisição.');
                                },
                            });
                        });

                    }
                });
                this.on('completemultiple', function() {
                    $btnSubmit.hide();
                    $wrapper.find('.preview').show();
                    this.removeAllFiles(true);
                })
            }
        });

        $btnRemove.on('click', function(e) {
            e.preventDefault();
            $.ajax({
                headers: {'X-CSRF-TOKEN': $(document).find('meta[name="csrf-token"]').attr('content')},
                type: 'POST',
                url: base + '/pt/minhas-acoes/actions',
                data: {action: 'remove-photo'},
                success: function(response) {
                    if(!response.error) {
                        $btnSubmit.show();
                        $wrapper.find('.preview').hide();
                    } else {
                        alert('Erro na requisição.');
                    }
                },
            });
        });

        $btnSubmit.on('click', function(e) {
            e.preventDefault();
        });
    }
};

uploadAvatar.init($('.avatar'), {content_type: 'avatars', w: 110, h: 110, crop: true, resize: true });

var $filterForm = $('#filter-form');

$('div.filtros .button').on('click', function(e) {
    e.preventDefault();
    var $btn = $(this);
    $('div.filtros .button').removeClass('active');
    $btn.addClass('active');

    $filterForm.find('[name="filter"]').val($btn.attr('data-filter'));
    $filterForm.find('[name="p"]').val('1');
    $filterForm.submit();
});
